module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki15_pc-b7cddb593a95920fce544e8171a0d219.jpg";